export default __webpack_public_path__ + "static/saleSticker-b190985d170fc91336599d5a58fbd346.svg";